import axios from 'axios';

export interface IngredientExportFilters {
  status: 'active' | 'inactive' | 'export' | 'development' | null;
  search?: string;
}

export const downloadIngredientsExcel = async (
  language?: string,
  filters?: IngredientExportFilters
) => {
  const apiUrl = process.env.REACT_APP_API_URL ?? '';
  const token = localStorage.getItem('token');
  const lang = (language || localStorage.getItem('i18nextLng') || 'mk').split('-')[0];

  const params: any = { lang };
  if (filters?.search) params.search = filters.search;
  if (filters?.status) params.status = filters.status;

  const response = await axios.get(`${apiUrl}/api/ingredients/export/excel`, {
    headers: { 'x-auth-token': token || '' },
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `ingredients_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
